/**
 * Product Header - LightGallery initialization for images and YouTube videos
 */

document.addEventListener("DOMContentLoaded", function () {
  const productCarousel = document.querySelector(".product-carousel");
  const carouselWrapper = document.querySelector(".product-carousel-wrapper");

  if (productCarousel) {
    // Initialize LightGallery with YouTube support
    const lg = jQuery(productCarousel).lightGallery({
      selector: ".product-media-item",
      download: false,
      counter: true,
      thumbnail: true,
      animateThumb: true,
      showThumbByDefault: false,
      youtubePlayerParams: {
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        controls: 1,
      },
      // Custom thumbnail for YouTube videos
      videoMaxWidth: "1280px",
      loadYoutubeThumbnail: true,
      youtubeThumbSize: "maxresdefault",
    });

    // Add click handler for YouTube videos
    const youtubeVideos = productCarousel.querySelectorAll(".youtube-video");
    youtubeVideos.forEach((video) => {
      video.addEventListener("click", function (e) {
        e.preventDefault();
        // LightGallery will handle the opening
      });
    });

    // Handle thumbnail clicks to open lightgallery at specific index
    const thumbnails = document.querySelectorAll(".carousel-thumb-item");
    const allMediaItems = productCarousel.querySelectorAll(
      ".product-media-item",
    );
    let currentIndex = 0;
    let autoplayInterval;

    // Function to show specific media item
    function showMediaItem(index) {
      allMediaItems.forEach((item, i) => {
        if (i === index) {
          item.classList.remove("hidden");
          item.classList.add("main-media");
        } else {
          item.classList.add("hidden");
          item.classList.remove("main-media");
        }
      });
      currentIndex = index;

      // Update thumbnail active state and scroll to it
      thumbnails.forEach((thumb) => {
        const thumbIndex = parseInt(thumb.dataset.thumbIndex);
        if (thumbIndex === index) {
          thumb.classList.add("border-primary");
          thumb.classList.remove("border-gray-200");

          // Scroll thumbnail into view smoothly without shifting layout
          const thumbnailsRow = thumb.closest(".carousel-thumbnails-row");
          if (thumbnailsRow) {
            const thumbRect = thumb.getBoundingClientRect();
            const containerRect = thumbnailsRow.getBoundingClientRect();
            const scrollLeft = thumbnailsRow.scrollLeft;
            const thumbOffset =
              thumbRect.left - containerRect.left + scrollLeft;
            const centerPosition =
              thumbOffset - containerRect.width / 2 + thumbRect.width / 2;

            thumbnailsRow.scrollTo({
              left: centerPosition,
              behavior: "smooth",
            });
          }
        } else {
          thumb.classList.remove("border-primary");
          thumb.classList.add("border-gray-200");
        }
      });
    }

    // Autoplay carousel
    function startAutoplay() {
      if (allMediaItems.length <= 1) return;

      autoplayInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % allMediaItems.length;
        showMediaItem(currentIndex);
      }, 3500); // Change every 3.5 seconds
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
      }
    }

    // Handle thumbnail clicks
    thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", function () {
        const index = parseInt(this.dataset.thumbIndex);
        showMediaItem(index);
        stopAutoplay(); // Stop autoplay when user clicks
      });

      // Desktop only: show image on hover
      if (window.matchMedia("(min-width: 1024px)").matches) {
        thumb.addEventListener("mouseenter", function () {
          const index = parseInt(this.dataset.thumbIndex);
          showMediaItem(index);
          stopAutoplay(); // Stop autoplay on hover too
        });

        thumb.addEventListener("mouseleave", function () {
          // Restart autoplay when leaving hover
          startAutoplay();
        });
      }
    });

    // Pause on hover
    if (carouselWrapper) {
      carouselWrapper.addEventListener("mouseenter", stopAutoplay);
      carouselWrapper.addEventListener("mouseleave", startAutoplay);
    }

    // Start autoplay
    if (allMediaItems.length > 1) {
      startAutoplay();
    }
  }

  // Add to favorites functionality (placeholder for now)
  const addToFavBtn = document.querySelector(".add-to-favorites");
  if (addToFavBtn) {
    addToFavBtn.addEventListener("click", function () {
      // TODO: Implement add to favorites functionality
      console.log("Add to favorites clicked");

      // Visual feedback
      const svg = this.querySelector("svg");
      svg.style.fill = "#F18E72";
      svg.style.transform = "scale(1.2)";

      setTimeout(() => {
        svg.style.transform = "scale(1)";
      }, 200);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      const targetId = this.getAttribute("data-accordion-toggle");
      const content = document.querySelector(
        `[data-accordion-content="${targetId}"]`,
      );
      const icon = this.querySelector(".accordion-icon");
      const plusIcon = icon.querySelector(".plus-icon");
      const minusIcon = icon.querySelector(".minus-icon");
      const isOpen = content.classList.contains("active");

      // Close all other accordions
      document.querySelectorAll(".accordion-content").forEach((c) => {
        if (c !== content) {
          c.classList.remove("active");
          const otherIcon =
            c.previousElementSibling.querySelector(".accordion-icon");
          otherIcon.querySelector(".plus-icon").classList.remove("hidden");
          otherIcon.querySelector(".minus-icon").classList.add("hidden");
        }
      });

      // Toggle current accordion
      if (isOpen) {
        content.classList.remove("active");
        plusIcon.classList.remove("hidden");
        minusIcon.classList.add("hidden");
      } else {
        content.classList.add("active");
        plusIcon.classList.add("hidden");
        minusIcon.classList.remove("hidden");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Wrapper le contenu de chaque <p> dans les infos complémentaires
  const complementaryInfos = document.querySelectorAll(
    ".complementary-info-content",
  );

  complementaryInfos.forEach(function (container) {
    const paragraphs = container.querySelectorAll("p");

    paragraphs.forEach(function (p) {
      // Créer un wrapper pour le contenu
      const wrapper = document.createElement("div");
      wrapper.className = "p-content";

      // Déplacer tout le contenu du p dans le wrapper
      wrapper.innerHTML = p.innerHTML;

      // Vider le p et ajouter le wrapper
      p.innerHTML = "";
      p.appendChild(wrapper);
    });
  });
});
